import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["maxWidth"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { cloneElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { closeModal } from './actions';
import { IconButton } from '../buttons';
import { CrossIcon } from '../icons';
const transition = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
  direction: "left",
  ref: ref
}, props)));
const Modal = _ref => {
  let {
    id,
    title,
    children,
    noCloseIcon = false,
    maxWidth = 'md',
    showTitle = true,
    className,
    titleClassName
  } = _ref;
  const dispatch = useDispatch();
  const {
    data
  } = useSelector(state => state.modal);
  const modalData = data === null || data === void 0 ? void 0 : data.find(modal => modal.id === id);
  if (!modalData) {
    return null;
  }

  // --
  const _ref2 = modalData.options || {},
    {
      maxWidth: oMaxWidth
    } = _ref2,
    childProps = _objectWithoutProperties(_ref2, _excluded);
  const onClose = () => dispatch(closeModal(id));
  const modal = /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    fullWidth: true,
    maxWidth: oMaxWidth || maxWidth,
    open: !!modalData,
    TransitionComponent: transition
  }, showTitle && /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    className: titleClassName
  }, modalData.title || title, !noCloseIcon && /*#__PURE__*/React.createElement(IconButton, {
    icon: CrossIcon,
    onClick: onClose,
    float: "right"
  })), /*#__PURE__*/React.createElement(DialogContent, {
    className: className
  }, modalData && /*#__PURE__*/cloneElement(children, childProps)));
  return modal;
};
Modal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.any,
  variant: PropTypes.string
};
export default Modal;